module.exports = __webpack_public_path__ + "media/partners/hand-shake-06d595d1.svg";